import "core-js/modules/es.array.join";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { serchSelect } from "@/mixins/index";
import { convertAmountRateSet, convertAmountRateUpdate } from "@/api/financial/consumptionDetails";
export default {
  mixins: [serchSelect],
  data: function data() {
    return {
      dialogFormVisible: false,
      searchData: {
        id: '',
        rate: "",
        special_product_id: ''
      },
      rules: {
        rate: [{
          required: true,
          message: this.$t('pleaseInput'),
          trigger: "blur"
        }, {
          pattern: /^(0\.\d+|1\.0+)$/,
          message: this.$t('conversionRatioRangeTip'),
          trigger: "blur"
        }],
        special_product_id: [{
          required: true,
          message: this.$t('selectProduct'),
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (data) {
                  _this.searchData.id = data.id;
                  _this.searchData.rate = data.rate;
                }

                _this.dialogFormVisible = true;

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    resetForm: function resetForm(formName) {
      this.dialogFormVisible = false;
      this.searchData = {
        id: '',
        rate: "",
        special_product_id: ''
      }, this.clearData();
    },
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this2 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var params = JSON.parse(JSON.stringify(_this2.searchData));
          var reqFn = params.id ? convertAmountRateUpdate : convertAmountRateSet;

          if (params.id) {
            delete params.special_product_id;
          } else {
            params.special_product_id = params.special_product_id.join(",");
          }

          reqFn(params).then(function (res) {
            if (res.status == 200) {
              _this2.$message.success(_this2.$t('operationSuccess'));

              _this2.$emit("refreshDataList");

              _this2.resetForm("ruleForm");
            }
          });
        }
      });
    },
    clearData: function clearData() {
      this.$refs.ruleForm.resetFields();
    }
  }
};